import { FormBlocksField, FormField } from '../form-field';

export const DEFAULT_DISCRIMINATOR = 'type';
export const DEFAULT_KEY_FIELD = 'key';

/**
 * The fields one block of a given type shows, in render order.
 *
 * The key and the discriminator lead and are `hidden`: both are real form controls the component
 * reads and writes, but the component renders the type picker and the list label itself, so letting
 * `universal-field` render them too would show each twice.
 */
export function blockFieldsFor(field: FormBlocksField, type: string): FormField[] {
    const definition = field.blockTypes.find((t) => t.value === type) ?? field.blockTypes[0];
    return [
        { type: 'hidden', name: field.keyField ?? DEFAULT_KEY_FIELD } as FormField,
        { type: 'hidden', name: field.discriminator ?? DEFAULT_DISCRIMINATOR } as FormField,
        ...(definition?.fields ?? []),
        ...(field.commonFields ?? [])
    ];
}

/**
 * A key that is unique within the chapter and does not encode position.
 *
 * Counts upward past every key already taken for this prefix and type rather than using the array
 * length: after a delete the length no longer matches the highest suffix, and reusing a key would
 * collide with a block still in the list.
 */
export function nextBlockKey(existingKeys: string[], prefix: string, type: string): string {
    const taken = new Set(existingKeys);
    const base = `${prefix}-${type}`;
    let n = 1;
    while (taken.has(`${base}-${n}`)) n++;
    return `${base}-${n}`;
}
